import {
  PopHistoryStackEntryAction,
  createPopHistoryStackEntryActionCreator,
} from '../history-stack';
import { ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX } from './constants';
import { AdminPanelsActionType } from './admin-panels-action-type';

export type PopAdminPanel = PopHistoryStackEntryAction<
  AdminPanelsActionType.Pop
>;

export const popAdminPanel = createPopHistoryStackEntryActionCreator<
  AdminPanelsActionType.Pop
>(ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX);
